import React from 'react';
import { connect } from 'react-redux';
import LightboxImages from '../Components/LightboxImages';
import { setCurrentIndex, show, previous, next } from '../Actions/LightboxImages.action';
import * as Slider from '../VanillaComponents/imageSlider';

function ActionLink(e) {
    let direction = e.currentTarget.classList[1];
    Slider.initiateSlider(direction);
}

const LightboxImagesContainer = props => <LightboxImages {...props} />;

const mapStateToProps = (state) => {    
    return {
        isOpen: state.lightboxImages.visible,
        currentImage: state.lightboxImages.index,
        swipeImage: (e) => ActionLink(e),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onClose: () => dispatch(show(false)),
        onClickNext: () => dispatch(next()),
        onClickPrev: () => dispatch(previous()),
        onClickThumbnail: (index) => {
            dispatch(show(true));
            dispatch(setCurrentIndex(index));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LightboxImagesContainer);